import { Meta } from 'src/presentation/components'
import {
  IconPhoneCall,
  IconClock,
  IconMail,
  IconMapPin,
} from '@tabler/icons-react'

import S from './contact.module.scss'

const Contact = () => (
  <div className={S.wrapper}>
    <Meta
      title="Fale Conosco"
      description="Entre em contato com a América Financeira."
      keywords="fale conosco, contato, América Financeira"
    />
    <div className={S.header}>
      <div className={S.box}>
        <h1 className={S.title}>Fale Conosco</h1>
      </div>
    </div>

    <div className={S.container}>
      <p className={S.subtitle}>Central de Atendimento</p>
      <div className={S.item}>
        <IconPhoneCall className={S.icon} />
        <span>(19) 3483-4454</span>
      </div>
      <div className={S.item}>
        <IconClock className={S.icon} />
        <span>De 2ª a 6ª das 8h00 as 18h00, exceto feriados</span>
      </div>
      <div className={S.item}>
        <IconMail className={S.icon} />
        <span>sac@americafinanceira.com.br</span>
      </div>
      <div className={S.item}>
        <IconMapPin className={S.icon} />
        <span>
          Av. Presidente Getulio Vargas. 834. 1° Andar. Santa Cruz - São Pedro -
          SP. CEP: 13521-156
        </span>
      </div>
    </div>
  </div>
)

export default Contact
